import {
  doFetchOne,
  doPatchOne,
  doDeleteSession,
  doFetchByDesignProjectId,
} from "@/services/session.service";
import humps from "lodash-humps";
import createHumps from "lodash-humps/lib/createHumps";
import { snakeCase } from "lodash";
const snakes = createHumps(snakeCase);

export const sessionOne = {
  namespaced: true,
  state: {
    one: {},
    inProgress: false,
    cartSessionOne: {},
  },
  mutations: {
    setSession(state, one) {
      state.one = one;
    },
    setSessionForCart(state, one) {
      state.cartSessionOne = one;
    },
    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
  },
  actions: {
    fetchOne: async ({ commit }, { sessionId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchOne({ sessionId });
        commit("setSession", humps(response));
        commit("inProgress", false);
        return { response: humps(response) };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchOneForCart: async ({ commit }, { sessionId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchOne({ sessionId });
        commit("setSessionForCart", humps(response));
        commit("inProgress", false);
        return { response: humps(response) };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    updateOne: async ({ commit }, { sessionId, property }) => {
      commit("inProgress", true);
      try {
        let response = await doPatchOne({
          sessionId,
          property: snakes(property),
        });
        commit("setSession", humps(response));
        commit("inProgress", false);
        return { response: humps(response) };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    updateOneForCart: async ({ commit }, { sessionId, property }) => {
      commit("inProgress", true);
      try {
        let response = await doPatchOne({
          sessionId,
          property: snakes(property),
        });
        commit("setSessionForCart", humps(response));
        commit("inProgress", false);
        return { response: humps(response) };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    deleteSession: async ({ commit }, { sessionId }) => {
      // eslint-disable-next-line no-debugger
      // debugger
      commit("inProgress", true);
      try {
        let deleteFlag = await doDeleteSession(sessionId);
        commit("inProgress", false);
        return deleteFlag;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchByDesignProjectId: async ({ commit }, { designProjectId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchByDesignProjectId({ designProjectId });
        commit("setSessionForCart", humps(response));
        commit("inProgress", false);
        return humps(response);
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
  },
};
